const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 08/12/16.
 */
const React = require('react');

import countryNameHelper from 'utilities/countryNameHelper';
const { connect } = require ('react-redux');
const { FormattedText, formatText } = require('core/i18n').i18n;
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const TaxationDataList = require('../TaxationDataList/TaxationDataList');
const formHelper = require('../../../utilities/formHelper');
const { fiocForeignTaxesTagging } = require('utilities/taggingInfo/fiocTags');
const getCountryISO3 = require("country-iso-2-to-3");


class ForeignTax extends React.Component {

    constructor(props) {
        super(props);
        let initialState;
        if (this.props.values) {
            if (this.props.values[0] !== (null || '')) {
                initialState = {
                    foreignTaxSelected: this.props.values[0],
                    component_id: 'foreignTax'
                }
            } else {
                initialState = {
                    foreignTaxSelected: null,
                    component_id: 'foreignTax'
                };
            }
        } else {
            initialState = {
                foreignTaxSelected: null,
                component_id: 'foreignTax'
            };
        }

        this.state = initialState;
        this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
        this.onDataReceiver = this.onDataReceiver.bind(this);
        this.buildRadioGroup = this.buildRadioGroup.bind(this);
    }

    onDataReceiver(data) {
        data = [this.state.foreignTaxSelected, data];
        this.props.dataReceiver(data);
    }

    buildRadioButton(radioButton) {
        return (
            <RadioButton
                label={radioButton.label}
                value={radioButton.value}
                key={radioButton.label}
                className="block-step__radio"
            />
        );
    }

    buildRadioGroup(radioOptions) {
        const errorMessage = formatText('contractsView-radioButtonsRequiredError');
        const { errorsState, id } = this.props;
        const error = (typeof errorsState[0] !== 'undefined') ? errorsState[0] : false;

        return (
            <RadioButtonGroup
                name={id}
                idPrefix={id}
                key={id}
                selectedValue={this.state.foreignTaxSelected}
                className="block-step__radio-group"
                onChange={this.handleRadioButtonChange}
                errorMessage={errorMessage}
                errorState={error}
            >
                {radioOptions}
            </RadioButtonGroup>
        );
    }

    handleRadioButtonChange(event) {
        event = formHelper.stringToBoolean(event);
        this.setState({foreignTaxSelected: event});
        fiocForeignTaxesTagging(event)
        this.props.dataReceiver([event, []]);
    }

    showTaxForm() {
        if (this.state.foreignTaxSelected) {
            return (<TaxationDataList
                formId={this.props.id}
                values={this.props.values !=null ? this.props.values[1] : []}
                taxCountryOptions={this.props.taxCountryOptions}
                imtOptions={this.props.imtOptions}
                dataReceiver={this.onDataReceiver}
                errorsState={this.props.errorsState}
                maxTributationCountries={this.props.maxTributationCountries}
                disableFinishButton={this.props.disableFinishButton}
                handleOnBlur={this.props.handleOnBlur}
                handleOnFocus={this.props.handleOnFocus}
            />);
        } else {
            return null;
        }
    }

    render() {
        const { originCountry } = this.props;
        const translatedCountry = countryNameHelper(getCountryISO3(originCountry));
        let radioOptions = [];
        this.props.radioOptions.forEach(option => {
            radioOptions.push(this.buildRadioButton(option));
        });
        switch (this.props.type) {
            case 'single':
                return (
                    <div>
                        <div className="ok-slider__text">
                            <FormattedText
                                value="contractsView-checkingAccountForeignTaxFirstRadioGroupTitleByCountry"
                                className="ok-slider__text"
                                injectedStrings={[translatedCountry]}
                            />
                        </div>
                        <div className="ok-slider__slider-box">
                            {this.buildRadioGroup(radioOptions)}
                        </div>
                        <div>
                            {this.showTaxForm()}
                        </div>
                    </div>);
            case 'form':
                return (
                    <div className="taxation-data">
                        <FormattedText
                            value="contractsView-checkingAccountForeignTaxSecondRadioGroupTitleByCountry"
                            className="ok-slider__text"
                            injectedStrings={[translatedCountry]}
                            />
                        <div >
                            {this.buildRadioGroup(radioOptions)}
                            <div>
                                {this.showTaxForm()}
                            </div>
                        </div>
                    </div>
                )
            default:
                return null;
        }
    }
}

ForeignTax.defaultProps = {
    type: 'single',
    maxTributationCountries: 4,
    originCountry: 'ES',
};

ForeignTax.propTypes = {
    radioOptions: PropTypes.array,
    taxCountryOptions: PropTypes.array,
    imtOptions: PropTypes.array,
    type: PropTypes.string,
    dataReceiver: PropTypes.func,
    values: PropTypes.any.isRequired,
    id: PropTypes.any.isRequired,
    errorsState: PropTypes.any.isRequired,
    maxTributationCountries: PropTypes.number,
    originCountry: PropTypes.string,
    disableFinishButton:PropTypes.func
};

module.exports = connect(
    state => ( {
        originCountry: state.profile.get('originCountry')
    }),
    null
    )(ForeignTax);
